const Joi = require("joi");

const revenueReportSchema = (data) => {
  const schema = Joi.object({
    actions: Joi.number().valid(1, 2, 3).required().messages({
      "any.required": "Action type is required.",
      "any.only": "Invalid action type selected.",
    }),

    fromDate: Joi.when("actions", {
      is: 3,
      then: Joi.string()
        .pattern(/^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/) // MM/dd/yyyy with slashes
        .required()
        .messages({
          "string.pattern.base":
            "Please ensure the From Date is in MM/dd/yyyy format.",
          "any.required": "Please enter From Date.",
          "string.empty": "Please enter From Date.",
        }),
      otherwise: Joi.string().allow(null, "").optional(),
    }),

    toDate: Joi.when("actions", {
      is: 3,
      then: Joi.string()
        .pattern(/^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/) // MM/dd/yyyy with slashes
        .required()
        .custom((value, helpers) => {
          const fromDate = helpers.state.ancestors[0].fromDate;
          if (fromDate) {
            const from = new Date(fromDate);
            const to = new Date(value);
            if (to <= from) {
              return helpers.error("date.invalid");
            }
          }
          return value;
        })
        .messages({
          "date.invalid":
            "Please ensure the To Date is greater than the From Date.",
          "string.base": "Please enter To Date.",
          "any.required": "Please enter To Date.",
          "string.empty": "Please enter To Date.",
        }),
      otherwise: Joi.string().allow(null, "").optional(),
    }),

    dobEndDate: Joi.when("actions", {
      is: 1,
      then: Joi.string()
        .pattern(/^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/) // MM/dd/yyyy with slashes
        .required()
        .messages({
          "string.pattern.base":
            "Please ensure the Date is in mm/dd/yyyy format.",
          "any.required": "Please enter Date.",
          "string.empty": "Please enter Date.",
        }),
      otherwise: Joi.string().allow(null, "").optional(),
    }),

    year: Joi.when("actions", {
      is: 2,
      then: Joi.number()
        .integer()
        .min(2000)
        .max(new Date().getFullYear()) // Ensuring it's a valid year
        .required()
        .messages({
          "any.required": "Please select Year.",
          "number.base": "Please select Year.",
          "number.min": "Please select Year.",
          "number.max": `Please ensure the Year is not greater than ${new Date().getFullYear()}.`,
        }),
      otherwise: Joi.number().allow(null).optional(),
    }),

    month: Joi.when("year", {
      is: Joi.number().integer().min(2000),
      then: Joi.number().integer().min(1).max(12).required().messages({
        "any.required": "Please select Month.",
        "number.base": "Please select Month.",
        "number.min": "Please select Month.",
        "number.max": "Please select Month.",
      }),
      otherwise: Joi.optional(),
    }),

    facilityId: Joi.when("records", {
      is: 2,
      then: Joi.number().integer().min(1).required().messages({
        "any.required": "Please select Facility Code.",
        "number.base": "Please select Facility Code.",
        "number.min": "Please select Facility Code.",
      }),
      otherwise: Joi.number().allow(null).optional(),
    }),
  }).unknown(true); // Allow additional properties in the object.

  return schema.validate(data, {
    abortEarly: false, // Return all errors instead of stopping at the first one
  });
};

module.exports = revenueReportSchema;
